import { fetchDataAsGeoJSON, fetchAllDataAsGeoJSON } from "../util";
export class RoutesProvider {
    constructor(apiHost, authObject, cacheSize = 50000) {
        this._apiHost = new URL(apiHost);
        this._authObject = authObject;
    }
    allRoutes(collection, simplify, segmentedonly, onSuccess, onError) {
        const url = `${this._apiHost.href}/routes/${collection}?simplify=${simplify}&segmentedonly=${segmentedonly}&limit=50000`;
        fetchAllDataAsGeoJSON(fetchDataAsGeoJSON, url, "GET", (geojson) => {
            onSuccess(geojson);
        }, onError, this._apiHost.origin, this._authObject);
    }
    allRoutesOutline(collection, onSuccess, onError) {
        const url = `${this._apiHost.href}/routes/${collection}/outline?limit=1`;
        fetchDataAsGeoJSON(url, "GET", (data) => {
            /*                 this._cache.setItem(cacheKey, geojson, null); */
            onSuccess(data.value);
        }, onError, this._authObject);
    }
    set authObject(authObject) {
        this._authObject = authObject;
    }
}
//# sourceMappingURL=routesprovider.js.map